import { useGetApiV1ClassroomdisciplineSharedCompanies } from '@/shared/api/generated';

import { mapDropdownOptions, useDebouncedFilter } from './useLookupSearch';

/**
 * Busca de empresas por texto (debounce + mínimo de 3 caracteres) para o
 * autocomplete de empresa. Consome o lookup `shared/companies` do Kubb.
 *
 * @param filter - Texto digitado no campo (default `''`).
 * @returns `{ options, isLoading, isQuerySuccess }`.
 */
export function useCompanySearchDropdown(filter = '') {
  const { debouncedFilter, isReady } = useDebouncedFilter(filter);

  const { data, isLoading, isSuccess } = useGetApiV1ClassroomdisciplineSharedCompanies(
    isReady ? { Search: debouncedFilter } : undefined,
    { query: { enabled: isReady } },
  );

  return { options: mapDropdownOptions(data), isLoading, isQuerySuccess: isSuccess } as const;
}
